// Logs exceptions via telemetry so HyperDX can capture them
import { telemetry } from '../backend';

interface ExtraData {
  [key: string]: string | number | undefined | null;
}

export default (
  error: Error | unknown,
  sourceFile: string,
  extraData: ExtraData = {},
  customData: { [key: string]: unknown } | undefined = undefined,
): void => {
  let telemetryMessage = '';
  telemetryMessage += `[deckeeSourceFile]: ${sourceFile},`;
  telemetryMessage += `[Error]: ${(error as any)?.message},`;
  if (Object.keys(extraData).length !== 0) {
    Object.entries(extraData).forEach(([key, value]) => {
      telemetryMessage += `[${key}]: ${JSON.stringify(value)},`;
    });
  }
  if (customData && Object.keys(customData).length !== 0) {
    Object.entries(customData).forEach(([key, value]) => {
      telemetryMessage += `[${key}]: ${JSON.stringify(value)}`;
    });
  }
  telemetry(telemetry.ERROR, telemetryMessage);
};
